<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">订单详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <div class="contentMain">
                    <div class="shopTitle">
                        <span>上林时光（长街店）</span>
                        <span>待付款</span>
                    </div>
                    <div class="leftContent">
                        <span>会员卡号</span>
                        <span>商品总价</span>
                        <span>折扣价格</span>
                        <span>优惠券</span>                        
                        <span>支付方式</span>
                        <span>实付金额</span>
                        <span>订单时间</span>
                        <span>订单号</span>
                    </div>
                    <div class="rightContent">
                        <span>SLSG 1083 4791 656</span>
                        <span>¥63.00</span>
                        <span>-¥1.00</span>
                        <span>-¥2.00</span>
                        <span>赊账</span>
                        <span>¥60.00</span>
                        <span>2018年8月2日  15:26</span>
                        <span>20180324100101001897</span>
                    </div>
                </div>
            </div>
            <div class="listTitle">上林时光（长街店）</div>
            <div class="goodsList">
                <ul>
                    <li class="goods">
                        <img src="../../assets/images/head.png" alt="">
                        <span>健康蔬菜套餐</span>
                        <span>100039</span>
                        <span>X1</span>
                        <span>¥59.90</span>
                    </li>
                </ul>
                <div class="more">
                    展开更多
                    <img class="arrowBottom" src="../../assets/images/arrowBottom.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui';
export default {
  data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1'   
    };
  },
  computed: {},
  components: {},
  methods: {     
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
  background-color: #ffffff;  
}
.contentMain{
    height: 7.84rem;
    width: 100%;
}
.shopTitle{ 
    position: relative;
    top: 0.3rem;
    left: 3.03rem;
}
.shopTitle :nth-child(1){
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
}
.shopTitle :nth-child(2){
    font-size: 0.37rem;
    color: rgba(246, 34, 65, 1);
    position: relative;
    right: -1.62rem;
}
.leftContent{
    width: 50%;
    height: 100%;
    float: left;
    position: relative;
    top: -0.8rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.rightContent{
    width: 50%;
    height: 100%;
    float: right;
    position: relative;
    top: -0.8rem;
    right: 0rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.leftContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    left: 0.53rem;
}
.leftContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    left: 0.53rem;
}
.leftContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    left: 0.53rem;
}
.leftContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    left: 0.53rem;
}
.leftContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    left: 0.53rem;
}
.leftContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    left: 0.53rem;
}
.leftContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    left: 0.53rem;
}
.leftContent :nth-child(8){
    position: absolute;
    top: 6.65rem;
    left: 0.53rem;
}
.rightContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    right: 0.37rem;
}
.rightContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    right: 0.37rem;
}
.rightContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    right: 0.37rem;
}
.rightContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    right: 0.37rem;
}
.rightContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    right: 0.37rem;
}
.rightContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    right: 0.37rem;
}
.rightContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    right: 0.37rem;
}
.rightContent :nth-child(8){
    position: absolute;
    top: 6.65rem;
    right: 0.37rem;
}
.listTitle{
    height: 0.85rem;
    line-height: 0;
    position: relative;
    left: 0.45rem;
    font-size: 0.37rem;
    color: #000000 90%;
}
.goodsList{
    background-color: #fff;
    height: 3.53rem;
    width: 100%;
}
.goods{
    width: 100%;
    height: 2.35rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.2);
    position: relative;
}
.goods :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.26rem;
    left: 0.45rem;
}
.goods :nth-child(2){
    position: absolute;
    top: 0.68rem;
    left: 2.8rem;
}
.goods :nth-child(3){
    position: absolute;
    top: 1.5rem;
    left: 2.8rem;
}
.goods :nth-child(4){
    position: absolute;
    top: 1.5rem;
    left: 4.5rem;
}
.goods :nth-child(5){
    position: absolute;
    top: 1rem;
    right: 0.47rem;
}
.more{
    text-align: center;
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.5);
    position: relative;
    top: 0.25rem;
}
.arrowBottom{
    width: 0.33rem;
    height: 0.33rem;
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/unpaidDetail.vue